import React from "react";

interface FloatRightProps {
    image: string;
    imageAlt: string;
    bullets: string[];
}

const SectionLeft: React.FC<FloatRightProps> = ({ image, imageAlt, bullets }) => {
    return (
        <>
            <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 order-xl-3">
                <img className="img-fluid mb-4 border-img" src={image} alt={imageAlt} />
            </div>
            <div className="col-12 col-xl-7 order-xl-4">
                <ul className="services pl-3">
                    {bullets.map((bullet, index) => (
                        <li key={index} className="mb-4">{bullet}</li>
                    ))}
                </ul>
            </div>
        </>
    );
};

export default SectionLeft;